"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouter = require("react-router");
var R = _interopRequireWildcard(require("ramda"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _helpers = require("@otpusk/apisearch-toolbox/dist/offers/helpers");
var _book = require("../../../../../../../routes/book");
var _price = require("../../../../../../../../helpers/price");
var _hocs = require("../../../../../../../../helpers/hocs");
var _handlers = require("../../../../../../../../helpers/handlers");
var _hocs2 = require("../../../../../../../Results/hocs");
var _Badge = _interopRequireWildcard(require("../../../../../../../ui/Badge"));
var _EditableContentControl = require("../../../../../../../ui/EditableContentControl");
var _EditButton = require("../../../../../../../CompactCardView/components/EditButton");
var _helpers2 = require("../../../../helpers");
var _highPriority = _interopRequireDefault(require("./icons/high-priority.svg"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["onOpenOfferDetailsModal"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DEFAULT_COUNTRY = 0;
var noop = function noop() {};
var prepareEditingValue = R.pipe(_price.roundPrice, String);
var Price = function Price(_ref) {
  var className = _ref.className,
    currency = _ref.currency,
    isHeightPromo = _ref.isHeightPromo,
    isMobile = _ref.isMobile,
    hotelID = _ref.hotelID,
    includes = _ref.includes,
    mbOfferKey = _ref.offerID,
    operatorID = _ref.operatorID,
    defaultDiscountPrice = _ref.discountPrice,
    bottomPrice = _ref.marginPrice,
    promoText = _ref.promoText,
    editedPrice = _ref.editedPrice,
    onClickByPrice = _ref.onClickByPrice,
    _ref$onEditingPrice = _ref.onEditingPrice,
    onEditingPrice = _ref$onEditingPrice === void 0 ? noop : _ref$onEditingPrice;
  var _useTranslation = (0, _reactI18next.useTranslation)(['RESULT_CARD', 'TOUR_OPTIONS']),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    editMode = _useState2[0],
    setEditMode = _useState2[1];
  var offerID = (0, _helpers.isOfferKey)(mbOfferKey) ? (0, _helpers.extractDataFromOfferKey)(mbOfferKey).id : mbOfferKey;
  var operatorSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getOperator)(), [{
      operatorID: operatorID,
      key: DEFAULT_COUNTRY
    }]);
  }, [operatorID]);
  var operator = (0, _reactRedux.useSelector)(operatorSelector);
  var shouldRenderGalaBadge = R.includes('gala', includes);
  var onConfirmEditPrice = (0, _react.useCallback)(function (newPrice) {
    var nextEditePriceAsNumber = Number(newPrice);
    onEditingPrice(nextEditePriceAsNumber);
    setEditMode(false);
  }, [onEditingPrice]);
  var topPrice = editedPrice || defaultDiscountPrice;
  var shouldRenderBottomPrice = R.and(bottomPrice, (0, _price.roundPrice)(topPrice) !== (0, _price.roundPrice)(bottomPrice));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(className, _styles.default.resultTourPrice, _defineProperty({}, _styles.default.showOldPrice, bottomPrice))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.resultTourPriceUah, editMode && _styles.default.editingPrice)
  }, editMode ? /*#__PURE__*/_react.default.createElement(_EditableContentControl.EditableContentControl, {
    className: _styles.default.editableControl,
    value: prepareEditingValue(topPrice),
    onClose: function onClose() {
      return setEditMode(false);
    },
    onConfirm: onConfirmEditPrice,
    getIsValidValue: function getIsValidValue(value) {
      try {
        (0, _helpers2.validateValueAsNumber)(value);
        return true;
      } catch (error) {
        return false;
      }
    },
    externalValueTransformer: _helpers2.handleComma
  }) : /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames3.default)(_styles.default.discountPrice, _defineProperty({}, _styles.default.edited, editedPrice)),
    href: (0, _reactRouter.generatePath)(_book.book.offer, {
      hotelID: hotelID,
      offerID: offerID
    }),
    onClick: onClickByPrice
  }, (0, _price.preparePriceForRender)(topPrice, currency.symbol), /*#__PURE__*/_react.default.createElement(_EditButton.EditButton, {
    className: _styles.default.editButton,
    onClick: (0, _handlers.handleWith)(_handlers.stop, _handlers.prevent, function () {
      return setEditMode(true);
    })
  })), isMobile && operator && /*#__PURE__*/_react.default.createElement("div", null, operator.name)), shouldRenderBottomPrice && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.oldPriceWrapper
  }, (0, _price.preparePriceForRender)(bottomPrice, currency.symbol)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultOperatorWrapper
  }, !isMobile && operator && /*#__PURE__*/_react.default.createElement("div", null, operator.name), promoText && /*#__PURE__*/_react.default.createElement(_Badge.default, {
    compact: true,
    color: isHeightPromo ? _Badge.COLORS.GREEN : _Badge.COLORS.YELLOW,
    tooltipContent: promoText
  }, "%"), shouldRenderGalaBadge && /*#__PURE__*/_react.default.createElement(_Badge.default, {
    compact: true,
    color: _Badge.COLORS.GREEN,
    icon: _highPriority.default,
    tooltipContent: t('GALA_DINNER')
  })));
};
Price.propTypes = {
  className: _propTypes.default.string,
  currency: _propTypes.default.shape({
    symbol: _propTypes.default.string.isRequired
  }).isRequired,
  discountPrice: _propTypes.default.number.isRequired,
  hotelID: _propTypes.default.number.isRequired,
  offerID: _propTypes.default.string.isRequired,
  includes: _propTypes.default.array,
  isHeightPromo: _propTypes.default.bool,
  marginPrice: _propTypes.default.number,
  operatorID: _propTypes.default.number,
  promoText: _propTypes.default.string,
  showOldPrice: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  editedPrice: _propTypes.default.number,
  onClickByPrice: _propTypes.default.func,
  onEditingPrice: _propTypes.default.func
};
Price.defaultProps = {
  includes: []
};
var enhancer = R.compose(_hocs2.withOpenOfferDetailsHandler, (0, _hocs.withMapProps)(function (_ref2) {
  var onClickByPrice = _ref2.onOpenOfferDetailsModal,
    props = _objectWithoutProperties(_ref2, _excluded);
  return R.mergeAll([props, {
    onClickByPrice: onClickByPrice
  }]);
}), _react.memo);
var _default = exports.default = enhancer(Price);